// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__oc3cS","title":"ClientReferral_title__36tGq","itemText":"ClientReferral_itemText__2zvbh"};